import React, { Fragment } from 'react';
import { BudgetProposalWithResourcesT } from 'routes/BudgetModule/config/types';
import { StyMultiStepModal } from '../../shared/StyMultiStepModal';
import { Typography } from '@mui/material';
import { translateBlockValue } from 'i18n';
import EditCustomCadrageGrid from './EditCustomCadrageGrid';
import Loading from 'components/Loading';
import { useGetCadrageSummary, useUpdateCustomCadrage } from '../hook';
import { useTranslation } from 'react-i18next';

type Props = {
    isModalShown: boolean;
    setShowModal: DispatchState<boolean>;
    budgetProposal: BudgetProposalWithResourcesT;
    trackEvent: (budgetProposalName: string) => void;
};

export default function EditCustomCadrageModal({
    isModalShown,
    setShowModal,
    budgetProposal,
    trackEvent,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const { data: cadrageSummary, isLoading } = useGetCadrageSummary(
        budgetProposal.id,
        isModalShown,
    );
    const { mutate: updateCustomCadrage } =
        useUpdateCustomCadrage(budgetProposal);
    const onConfirmAction = () => {
        if (!cadrageSummary) return;
        updateCustomCadrage({
            customCadrage: cadrageSummary.map((cadrageItem) => {
                return {
                    resource: cadrageItem.resource.softwareId ?? '',
                    chapter: cadrageItem.chapter,
                    amount: cadrageItem.customAmount,
                };
            }),
        });
        trackEvent(budgetProposal.name);
    };

    const steps = [
        {
            disableClose: true,
            confirmAction: {
                label: 'common.confirm',
                onClick: onConfirmAction,
            },
            stepBackAction: {
                onClick: () => {
                    setShowModal(false);
                },
                enabled: true,
                label: 'common.cancel',
            },
            node: (
                <Fragment key="step-confirmation">
                    <Typography variant="h4" sx={{ paddingBottom: '1.5em' }}>
                        {t('adminBudgetSpace.cadrage.editCustomTitle', {
                            budgetCode: budgetProposal.budgetCode,
                            budgetName: budgetProposal.budgetName,
                            section: translateBlockValue(
                                budgetProposal.section ?? '',
                            ),
                        })}
                    </Typography>
                    {!isLoading && cadrageSummary ? (
                        <EditCustomCadrageGrid
                            cadrageSummary={cadrageSummary}
                            by={budgetProposal.by}
                            byChapter={budgetProposal.cadrageByChapter}
                        />
                    ) : (
                        <Loading />
                    )}
                </Fragment>
            ),
        },
    ];
    return (
        <StyMultiStepModal
            isOpen={isModalShown}
            onClose={() => {
                setShowModal(false);
            }}
            maxWidth="lg"
            steps={steps}
            showCloseIcon={true}
        />
    );
}
